import * as React from 'react';
import { forwardRef } from 'react';

export const LBWhatsUpIcon = forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<'svg'>
>((props, ref) => (
  <svg
    {...props}
    ref={ref}
    fill='none'
    height={25}
    width={24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M.515 11.946c0 2.032.53 4.015 1.54 5.764L.418 23.684l6.114-1.603a11.527 11.527 0 0 0 5.511 1.403h.006c6.356 0 11.53-5.172 11.532-11.529A11.458 11.458 0 0 0 20.206 3.8 11.46 11.46 0 0 0 12.048.417C5.691.417.518 5.59.515 11.946'
      fill='currentColor'
    />
    <path
      d='M9.065 6.95c-.224-.497-.46-.507-.672-.516-.174-.008-.373-.007-.572-.007-.2 0-.523.075-.796.373-.274.3-1.045 1.021-1.045 2.49 0 1.468 1.07 2.888 1.219 3.087.15.2 2.065 3.31 5.099 4.506 2.522.994 3.035.796 3.582.747.547-.05 1.766-.722 2.015-1.42.249-.696.249-1.294.174-1.419-.075-.124-.274-.199-.572-.348-.299-.15-1.766-.871-2.04-.971-.274-.1-.473-.15-.672.15-.199.298-.77.97-.945 1.17-.174.199-.348.224-.646.075-.299-.15-1.26-.465-2.4-1.482-.888-.791-1.487-1.768-1.662-2.067-.174-.299-.018-.46.131-.61.135-.133.3-.348.448-.522.15-.174.199-.299.299-.498.1-.199.05-.373-.025-.523-.075-.149-.655-1.625-.92-2.215Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='a'
        x1={1158.56}
        x2={1158.56}
        y1={2327.12}
        y2={0.417}
      >
        <stop stopColor='#1FAF38' />
        <stop offset={1} stopColor='#60D659' />
      </linearGradient>
    </defs>
  </svg>
));
